import { useState, useEffect, useRef } from 'react';

const TR = {
  nav: { features: 'Özellikler', pricing: 'Fiyatlar', faq: 'SSS', contact: 'İletişim', login: 'Giriş Yap' },
  hero: {
    badge: 'Yeni Nesil QR Menü Sistemi',
    title1: 'Kağıt Menü',
    title2: 'Devri Bitti.',
    subtitle: 'Müşterileriniz QR kodu okutarak saniyeler içinde menüye ulaşsın, sipariş versin, hesap istesin. Siz sadece lezzetli yemeklerinize odaklanın.',
    cta: 'Hemen Başla',
    whatsapp: 'WhatsApp\'tan Yaz',
  },
  stats: [
    { value: '3', unit: 'dk', label: 'Kurulum süresi' },
    { value: '100', unit: '%', label: 'Mobil uyumlu' },
    { value: '7/24', unit: '', label: 'Kesintisiz hizmet' },
    { value: '0', unit: '₺', label: 'Donanım maliyeti' },
  ],
  features: {
    title: 'Her Şey Düşünüldü',
    subtitle: 'Kafenizi dijitalleştirmek için ihtiyacınız olan her şey tek platformda.',
    list: [
      { icon: '📱', title: 'QR ile Anında Erişim', desc: 'Her masa için ayrı QR kod. Müşteri okuttu, menü açıldı. Bu kadar basit.' },
      { icon: '🛒', title: 'Dijital Sipariş', desc: 'Müşteriler doğrudan telefondan sipariş verebilir. Garson yükü azalır, hata sıfırlanır.' },
      { icon: '🔔', title: 'Garson Çağırma', desc: 'Tek tuşla garson çağrısı. Kasa ekranında anlık bildirim ve sesli uyarı.' },
      { icon: '💳', title: 'Hesap İsteme', desc: 'Müşteri hesap istediğinde kasa ekranına anında bildirim düşer.' },
      { icon: '📊', title: 'Ciro Raporları', desc: 'Günlük ciro, masa bazlı harcama, saatlik grafik — hepsi tek ekranda.' },
      { icon: '🎬', title: 'Video & Sosyal Medya', desc: 'Menüye tanıtım videosu ve sosyal medya bağlantıları ekleyin.' },
      { icon: '🖼️', title: 'Görsel Menü', desc: 'Her ürüne fotoğraf ekleyin. Müşteriler ne sipariş ettiklerini görerek karar versin.' },
      { icon: '⚡', title: 'Anında Güncelleme', desc: 'Fiyat değişikliği, yeni ürün — tüm değişiklikler anında yansır.' },
      { icon: '✨', title: 'AI Destekli Menü', desc: 'Yapay zeka ile otomatik kalori hesaplama ve alerjen uyarı sistemi.' },
    ],
  },
  compare: {
    title: 'Kağıt Menü mu?',
    subtitle: 'Farkı görün.',
    old: { label: 'Kağıt Menü', items: ['Baskı & güncelleme masrafı', 'Kirli ve yıpranmış kağıtlar', 'Garson hatalarından kayıp', 'Müşteri verisi yok', 'Fiyat güncellemesi = yeni baskı'] },
    new: { label: '3AMenu', items: ['Sıfır baskı maliyeti', 'Her zaman temiz & güncel', 'Dijital sipariş, hata sıfır', 'Müşteri davranışı analizi', 'Tek tıkla fiyat güncelleme'] },
  },
  howit: {
    title: 'Nasıl Çalışır?',
    subtitle: '3 adımda dijital menünüz hazır.',
    steps: [
      { num: '01', icon: '💬', title: 'Bize Ulaşın', desc: 'WhatsApp veya mail üzerinden iletişime geçin. Dakikalar içinde hesabınızı oluşturalım.' },
      { num: '02', icon: '🍽️', title: 'Menünü Yükle', desc: 'Admin panelinden kategorileri, ürünleri ve fotoğrafları kolayca ekleyin. AI ile kalori ve alerjen bilgisi otomatik gelsin.' },
      { num: '03', icon: '🖨️', title: 'QR Kodu Yazdır', desc: 'Her masa için QR kodu indirin, yazdırın ve masaya koyun. Müşterileriniz anında siparişe hazır!' },
    ],
  },
  pricing: {
    title: 'Şeffaf Fiyatlandırma',
    subtitle: 'Gizli ücret yok. İstediğiniz zaman iptal edin.',
    monthly: 'Aylık',
    yearly: 'Yıllık',
    save: '%17 Tasarruf',
    plans: [
      {
        name: 'Standart',
        monthlyPrice: '990',
        yearlyPrice: '9.900',
        desc: 'Dijital menüye geçmek isteyen kafeler için ideal başlangıç paketi.',
        features: [
          'QR Menü & QR Kod Üretici',
          'Sınırsız Kategori & Ürün',
          'Dijital Sipariş Sistemi',
          'Garson Çağırma & Hesap İsteme',
          'Günlük & Haftalık Ciro Raporları',
          'Görsel Menü (Fotoğraf Desteği)',
          'Sosyal Medya & Video Entegrasyonu',
          'Blur Video Arka Plan',
          'Sesli Bildirimler',
          'TR / EN Dil Desteği',
        ],
        cta: 'Standart Başla',
        popular: false,
      },
      {
        name: 'Pro',
        monthlyPrice: '1.890',
        yearlyPrice: '18.900',
        desc: 'Deneyimi zirveye taşımak ve müşteri bağlılığı oluşturmak isteyenler için.',
        features: [
          'Standart\'taki her şey +',
          'Yapay Zeka Destekli Menü',
          'Otomatik Kalori & Alerjen Sistemi',
          'AI Ürün Açıklaması Oluşturucu',
          'Sadakat Kartı Sistemi (SMS OTP)',
          'Kampanya & İndirim Yönetimi',
          'Öne Çıkan Ürün Şeridi',
          'Aksiyon Butonları',
          'AR / RU Dil Desteği',
          'Öncelikli Destek',
        ],
        cta: 'Pro Başla',
        popular: true,
      },
    ],
  },
  faq: {
    title: 'Sık Sorulan Sorular',
    subtitle: 'Aklınızdaki her sorunun cevabı burada.',
    list: [
      { q: 'Kurulum ne kadar sürer?', a: 'Hesabınızı oluşturduktan sonra admin panelinden menünüzü yüklemek ortalama 15-30 dakika sürer. QR kodları anında oluşturulur ve yazdırılmaya hazırdır.' },
      { q: 'Müşteriler uygulama indirmek zorunda mı?', a: 'Hayır! Müşteriler telefonlarındaki kamerayı QR koda tutarak direkt tarayıcıda menüyü açar. Uygulama indirmeye gerek yoktur.' },
      { q: 'Menüyü sonradan güncelleyebilir miyim?', a: 'Evet, dilediğiniz zaman admin panelinden fiyat değiştirebilir, yeni ürün ekleyebilir veya ürün kaldırabilirsiniz. Değişiklikler anında yansır.' },
      { q: 'İnternet olmadan çalışır mı?', a: 'Hem sizin hem de müşterilerinizin internete bağlı olması gerekir. Ancak menü çok hafiftir, 3G bağlantıyla bile sorunsuz çalışır.' },
      { q: 'Birden fazla şubeyi yönetebilir miyim?', a: 'Evet! Pro planda her şube için ayrı menü ve QR kod oluşturabilirsiniz. Tüm şubeleri tek hesaptan yönetirsiniz.' },
      { q: 'Ödeme nasıl yapılır?', a: 'Aylık veya yıllık olarak ödeme yapabilirsiniz. Yıllık ödemede %17 tasarruf edersiniz. Kredi kartı veya havale ile ödeme kabul edilmektedir.' },
      { q: 'Sözleşme var mı?', a: 'Hayır, herhangi bir uzun dönemli sözleşme yoktur. İstediğiniz zaman iptal edebilirsiniz.' },
      { q: 'Teknik destek alabilir miyim?', a: 'Standart planda e-posta ve WhatsApp desteği, Pro planda öncelikli destek sunulmaktadır. Her türlü sorunuzda yanınızdayız.' },
    ],
  },
  cta: {
    title: 'Kafenizi Geleceğe Taşıyın',
    subtitle: 'Hemen demo talep edin, sistemi ücretsiz deneyin.',
    button: 'WhatsApp\'tan Yaz',
  },
  footer: {
    rights: '© 2025 3AMenu — 3A Creative',
    links: ['Gizlilik Politikası', 'Kullanım Koşulları'],
  },
};

const EN = {
  nav: { features: 'Features', pricing: 'Pricing', faq: 'FAQ', contact: 'Contact', login: 'Login' },
  hero: {
    badge: 'Next-Gen QR Menu System',
    title1: 'Paper Menus',
    title2: 'Are History.',
    subtitle: 'Let your customers scan a QR code, browse the menu, order, and request the bill — all from their phone. You focus on great food.',
    cta: 'Get Started',
    whatsapp: 'Message on WhatsApp',
  },
  stats: [
    { value: '3', unit: 'min', label: 'Setup time' },
    { value: '100', unit: '%', label: 'Mobile friendly' },
    { value: '24/7', unit: '', label: 'Always online' },
    { value: '0', unit: '₺', label: 'Hardware cost' },
  ],
  features: {
    title: 'Everything Covered',
    subtitle: 'All you need to digitize your café, in one platform.',
    list: [
      { icon: '📱', title: 'Instant QR Access', desc: 'Unique QR per table. Customer scans, menu opens. That simple.' },
      { icon: '🛒', title: 'Digital Ordering', desc: 'Customers order directly from their phone. Less waiter load, zero errors.' },
      { icon: '🔔', title: 'Waiter Call', desc: 'One tap to call the waiter. Instant notification with sound alert on POS.' },
      { icon: '💳', title: 'Bill Request', desc: 'When a customer requests the bill, the cashier gets an instant notification.' },
      { icon: '📊', title: 'Revenue Reports', desc: 'Daily revenue, per-table spending, hourly chart — all in one screen.' },
      { icon: '🎬', title: 'Video & Social', desc: 'Add a promo video and social media links to your menu.' },
      { icon: '🖼️', title: 'Visual Menu', desc: 'Add photos to every product. Customers decide knowing what they\'re ordering.' },
      { icon: '⚡', title: 'Instant Updates', desc: 'Price change, new item — all changes reflect instantly.' },
      { icon: '✨', title: 'AI-Powered Menu', desc: 'Automatic calorie calculation and allergen warning system with AI.' },
    ],
  },
  compare: {
    title: 'Paper Menu?',
    subtitle: 'See the difference.',
    old: { label: 'Paper Menu', items: ['Printing & update costs', 'Dirty and worn papers', 'Losses from waiter errors', 'No customer data', 'Price update = new print'] },
    new: { label: '3AMenu', items: ['Zero printing cost', 'Always clean & up-to-date', 'Digital orders, zero errors', 'Customer behavior analytics', 'One-click price updates'] },
  },
  howit: {
    title: 'How It Works',
    subtitle: 'Your digital menu ready in 3 steps.',
    steps: [
      { num: '01', icon: '💬', title: 'Contact Us', desc: 'Reach out via WhatsApp or email. We\'ll set up your account in minutes.' },
      { num: '02', icon: '🍽️', title: 'Upload Menu', desc: 'Add categories, products, and photos from the admin panel. AI auto-fills calories and allergens.' },
      { num: '03', icon: '🖨️', title: 'Print QR Codes', desc: 'Download QR codes for each table, print, and place them. Customers are ready to order!' },
    ],
  },
  pricing: {
    title: 'Transparent Pricing',
    subtitle: 'No hidden fees. Cancel anytime.',
    monthly: 'Monthly',
    yearly: 'Yearly',
    save: '17% Off',
    plans: [
      {
        name: 'Standard',
        monthlyPrice: '990',
        yearlyPrice: '9,900',
        desc: 'The perfect starter package for cafés ready to go digital.',
        features: [
          'QR Menu & QR Code Generator',
          'Unlimited Categories & Items',
          'Digital Order System',
          'Waiter Call & Bill Request',
          'Daily & Weekly Revenue Reports',
          'Visual Menu (Photo Support)',
          'Social Media & Video Integration',
          'Blur Video Background',
          'Sound Notifications',
          'TR / EN Language Support',
        ],
        cta: 'Start Standard',
        popular: false,
      },
      {
        name: 'Pro',
        monthlyPrice: '1,890',
        yearlyPrice: '18,900',
        desc: 'For those who want the ultimate experience and customer loyalty.',
        features: [
          'Everything in Standard +',
          'AI-Powered Menu',
          'Auto Calorie & Allergen System',
          'AI Product Description Generator',
          'Loyalty Card System (SMS OTP)',
          'Campaign & Discount Management',
          'Featured Products Strip',
          'Action Buttons',
          'AR / RU Language Support',
          'Priority Support',
        ],
        cta: 'Start Pro',
        popular: true,
      },
    ],
  },
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Every answer you need, right here.',
    list: [
      { q: 'How long does setup take?', a: 'After creating your account, uploading your menu from the admin panel takes about 15-30 minutes. QR codes are generated instantly and ready to print.' },
      { q: 'Do customers need to download an app?', a: 'No! Customers simply point their phone camera at the QR code and the menu opens directly in their browser. No app download required.' },
      { q: 'Can I update the menu later?', a: 'Yes, you can change prices, add new items, or remove items from the admin panel at any time. Changes are reflected instantly.' },
      { q: 'Does it work without internet?', a: 'Both you and your customers need an internet connection. However, the menu is very lightweight and works smoothly even on 3G.' },
      { q: 'Can I manage multiple branches?', a: 'Yes! With the Pro plan, you can create separate menus and QR codes for each branch, managed from a single account.' },
      { q: 'How is payment made?', a: 'You can pay monthly or annually. Annual payment saves you 17%. Credit card or bank transfer are accepted.' },
      { q: 'Is there a contract?', a: 'No long-term contracts. You can cancel anytime.' },
      { q: 'Can I get technical support?', a: 'Standard plan includes email and WhatsApp support. Pro plan includes priority support. We\'re always here for you.' },
    ],
  },
  cta: {
    title: 'Take Your Café to the Future',
    subtitle: 'Request a demo now and try the system for free.',
    button: 'Message on WhatsApp',
  },
  footer: {
    rights: '© 2025 3AMenu — 3A Creative',
    links: ['Privacy Policy', 'Terms of Service'],
  },
};

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}

function Counter({ value, unit, duration = 1500 }) {
  const [count, setCount] = useState(0);
  const [ref, inView] = useInView(0.5);
  const numericValue = parseFloat(value.replace(',', '.'));
  useEffect(() => {
    if (!inView || isNaN(numericValue)) return;
    let start = 0;
    const step = numericValue / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= numericValue) { setCount(numericValue); clearInterval(timer); }
      else setCount(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [inView, numericValue]);
  if (isNaN(numericValue)) return <span ref={ref}>{value}{unit}</span>;
  return <span ref={ref}>{count}{unit}</span>;
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div onClick={() => setOpen(!open)} style={{ border: '1px solid', borderColor: open ? 'rgba(249,115,22,0.3)' : '#1a1a1a', borderRadius: 14, padding: '20px 24px', cursor: 'pointer', transition: 'all 0.3s', background: open ? 'rgba(249,115,22,0.04)' : '#0d0d0d', marginBottom: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
        <span style={{ fontSize: 15, fontWeight: 600, color: open ? '#fff' : '#aaa', lineHeight: 1.4 }}>{q}</span>
        <span style={{ color: '#f97316', fontSize: 20, flexShrink: 0, transition: 'transform 0.3s', transform: open ? 'rotate(45deg)' : 'rotate(0deg)', display: 'inline-block' }}>+</span>
      </div>
      {open && <p style={{ fontSize: 14, color: '#666', lineHeight: 1.8, marginTop: 14, paddingTop: 14, borderTop: '1px solid #1a1a1a' }}>{a}</p>}
    </div>
  );
}

export default function LandingPage() {
  const [lang, setLang] = useState('tr');
  const [billing, setBilling] = useState('monthly');
  const [scrolled, setScrolled] = useState(false);
  const t = lang === 'tr' ? TR : EN;
  const WA = 'https://wa.me/905324490381';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const [heroRef, heroInView] = useInView(0.1);
  const [statsRef, statsInView] = useInView(0.2);
  const [featRef, featInView] = useInView(0.1);
  const [compareRef, compareInView] = useInView(0.2);
  const [howitRef, howitInView] = useInView(0.2);
  const [pricingRef, pricingInView] = useInView(0.1);
  const [faqRef, faqInView] = useInView(0.1);

  return (
    <div style={{ fontFamily: "'Syne', sans-serif", background: '#080808', color: '#fff', minHeight: '100vh', overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }
        ::-webkit-scrollbar { width: 4px; }
        ::-webkit-scrollbar-track { background: #080808; }
        ::-webkit-scrollbar-thumb { background: #f97316; border-radius: 2px; }
        .fade-up { opacity: 0; transform: translateY(40px); transition: opacity 0.7s cubic-bezier(.22,1,.36,1), transform 0.7s cubic-bezier(.22,1,.36,1); }
        .fade-up.in { opacity: 1; transform: translateY(0); }
        .fade-up.d1 { transition-delay: 0.1s; } .fade-up.d2 { transition-delay: 0.2s; }
        .fade-up.d3 { transition-delay: 0.3s; } .fade-up.d4 { transition-delay: 0.4s; }
        .nav-link { color: #666; text-decoration: none; font-size: 14px; font-weight: 500; transition: color 0.2s; cursor: pointer; }
        .nav-link:hover { color: #fff; }
        .btn-orange { background: #f97316; color: #fff; border: none; border-radius: 10px; padding: 13px 26px; font-size: 14px; font-weight: 700; cursor: pointer; transition: all 0.25s; font-family: 'Syne', sans-serif; text-decoration: none; display: inline-flex; align-items: center; gap: 8px; }
        .btn-orange:hover { background: #ea6d15; transform: translateY(-1px); box-shadow: 0 12px 40px rgba(249,115,22,0.35); }
        .btn-ghost { background: transparent; color: #fff; border: 1px solid rgba(255,255,255,0.15); border-radius: 10px; padding: 13px 26px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.25s; font-family: 'Syne', sans-serif; text-decoration: none; display: inline-flex; align-items: center; gap: 8px; }
        .btn-ghost:hover { border-color: #f97316; color: #f97316; }
        .feat-card { background: #0f0f0f; border: 1px solid #1a1a1a; border-radius: 16px; padding: 28px; transition: all 0.3s; }
        .feat-card:hover { border-color: rgba(249,115,22,0.4); background: #131313; transform: translateY(-3px); box-shadow: 0 20px 60px rgba(249,115,22,0.06); }
        .pricing-card { background: #0f0f0f; border: 1px solid #1c1c1c; border-radius: 20px; padding: 36px; transition: all 0.3s; position: relative; overflow: hidden; }
        .pricing-card.popular { border-color: #f97316; background: linear-gradient(160deg, #0f0f0f 0%, #160a00 100%); }
        .pricing-card.popular::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px; background: linear-gradient(90deg, #f97316, #fb923c, #f97316); }
        .step-card { background: #0c0c0c; border: 1px solid #1a1a1a; border-radius: 20px; padding: 36px; transition: all 0.3s; }
        .step-card:hover { border-color: rgba(249,115,22,0.3); }
        .compare-item { display: flex; align-items: center; gap: 10px; padding: 10px 0; border-bottom: 1px solid #1a1a1a; font-size: 14px; }
        .compare-item:last-child { border-bottom: none; }
        .noise { position: fixed; inset: 0; pointer-events: none; z-index: 0; opacity: 0.025; background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E"); }
        .grid-bg { background-image: linear-gradient(rgba(249,115,22,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(249,115,22,0.04) 1px, transparent 1px); background-size: 60px 60px; }
        .tag { display: inline-flex; align-items: center; gap: 6px; background: rgba(249,115,22,0.08); border: 1px solid rgba(249,115,22,0.2); border-radius: 100px; padding: 5px 14px; font-size: 12px; color: #f97316; font-weight: 600; letter-spacing: 0.05em; text-transform: uppercase; }
        .phone-mockup { background: #111; border-radius: 36px; padding: 10px; box-shadow: 0 0 0 1px #222, 0 40px 80px rgba(0,0,0,0.6), 0 0 80px rgba(249,115,22,0.08); }
        .phone-screen { background: #0a0a0a; border-radius: 28px; overflow: hidden; }
        @keyframes float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-12px)} }
        @keyframes shimmer { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
        @keyframes spin-slow { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
        @keyframes ticker { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }
        .float { animation: float 4s ease-in-out infinite; }
        .shimmer-text { background: linear-gradient(90deg, #f97316 0%, #fb923c 30%, #fff 50%, #fb923c 70%, #f97316 100%); background-size: 200% auto; -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; animation: shimmer 4s linear infinite; }
        @media (max-width: 768px) {
          .hero-grid { grid-template-columns: 1fr !important; }
          .feat-grid { grid-template-columns: 1fr 1fr !important; }
          .stats-grid { grid-template-columns: 1fr 1fr !important; }
          .pricing-grid { grid-template-columns: 1fr !important; }
          .howit-grid { grid-template-columns: 1fr !important; }
          .compare-grid { grid-template-columns: 1fr !important; }
          .hero-phone { display: none !important; }
          .nav-desktop { display: none !important; }
          .faq-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 480px) { .feat-grid { grid-template-columns: 1fr !important; } }
      `}</style>

      <div className="noise" />

      {/* Navbar */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, background: scrolled ? 'rgba(8,8,8,0.92)' : 'transparent', backdropFilter: scrolled ? 'blur(20px)' : 'none', borderBottom: scrolled ? '1px solid #141414' : '1px solid transparent', transition: 'all 0.4s', padding: '0 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 68 }}>
          <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 2 }}>
            <span style={{ fontSize: 24, fontWeight: 800, color: '#f97316' }}>3A</span>
            <span style={{ fontSize: 24, fontWeight: 800, color: '#fff' }}>Menu</span>
          </a>
          <div className="nav-desktop" style={{ display: 'flex', alignItems: 'center', gap: 36 }}>
            <a href="#features" className="nav-link">{t.nav.features}</a>
            <a href="#pricing" className="nav-link">{t.nav.pricing}</a>
            <a href="#faq" className="nav-link">{t.nav.faq}</a>
            <a href="#contact" className="nav-link">{t.nav.contact}</a>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ display: 'flex', background: '#111', border: '1px solid #1e1e1e', borderRadius: 8, padding: 3, gap: 2 }}>
              {['tr', 'en'].map(l => (
                <button key={l} onClick={() => setLang(l)} style={{ background: lang === l ? '#f97316' : 'transparent', color: lang === l ? '#fff' : '#555', border: 'none', borderRadius: 6, padding: '4px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'Syne', transition: 'all 0.2s' }}>{l.toUpperCase()}</button>
              ))}
            </div>
            <a href="/login" className="btn-orange" style={{ padding: '9px 18px', fontSize: 13 }}>{t.nav.login}</a>
          </div>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', position: 'relative', overflow: 'hidden', paddingTop: 80 }} className="grid-bg">
        <div style={{ position: 'absolute', width: 700, height: 700, borderRadius: '50%', background: 'radial-gradient(circle, rgba(249,115,22,0.12) 0%, transparent 70%)', top: -200, right: -200, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(249,115,22,0.06) 0%, transparent 70%)', bottom: 100, left: -100, pointerEvents: 'none' }} />

        <div ref={heroRef} style={{ maxWidth: 1200, margin: '0 auto', padding: '80px 24px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 80, alignItems: 'center', width: '100%', position: 'relative', zIndex: 1 }} className="hero-grid">
          <div>
            <div className={`fade-up ${heroInView ? 'in' : ''}`}>
              <div className="tag" style={{ marginBottom: 28 }}><span style={{ width: 5, height: 5, background: '#f97316', borderRadius: '50%', display: 'inline-block' }} />{t.hero.badge}</div>
            </div>
            <div className={`fade-up d1 ${heroInView ? 'in' : ''}`}>
              <h1 style={{ fontFamily: "'Syne', sans-serif", fontSize: 'clamp(44px, 5vw, 76px)', fontWeight: 800, lineHeight: 1.05, marginBottom: 24, letterSpacing: '-0.02em' }}>
                {t.hero.title1}<br /><span className="shimmer-text">{t.hero.title2}</span>
              </h1>
            </div>
            <div className={`fade-up d2 ${heroInView ? 'in' : ''}`}>
              <p style={{ fontSize: 17, color: '#777', lineHeight: 1.8, marginBottom: 40, maxWidth: 460 }}>{t.hero.subtitle}</p>
            </div>
            <div className={`fade-up d3 ${heroInView ? 'in' : ''}`} style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
              <a href={WA} target="_blank" rel="noreferrer" className="btn-orange">{t.hero.cta} →</a>
              <a href={WA} target="_blank" rel="noreferrer" className="btn-ghost">💬 {t.hero.whatsapp}</a>
            </div>
            <div className={`fade-up d4 ${heroInView ? 'in' : ''}`} style={{ marginTop: 48, display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{ display: 'flex' }}>
                {['🧑‍🍳', '👨‍💼', '👩‍🍳', '🧑‍💼'].map((e, i) => (
                  <div key={i} style={{ width: 32, height: 32, borderRadius: '50%', background: `hsl(${20 + i * 15},80%,${30 + i * 5}%)`, border: '2px solid #080808', marginLeft: i === 0 ? 0 : -8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>{e}</div>
                ))}
              </div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>50+ Kafe güveniyor</div>
                <div style={{ fontSize: 11, color: '#f97316', marginTop: 2 }}>⭐⭐⭐⭐⭐</div>
              </div>
            </div>
          </div>

          {/* Telefon mockup */}
          <div className={`fade-up d2 ${heroInView ? 'in' : ''} hero-phone`} style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="float">
              <div className="phone-mockup" style={{ width: 260 }}>
                <div className="phone-screen">
                  <div style={{ background: 'linear-gradient(160deg, #1a0a00 0%, #0f0f0f 100%)', padding: '32px 20px 24px', textAlign: 'center', borderBottom: '1px solid #1a1a1a' }}>
                    <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'rgba(249,115,22,0.15)', border: '2px solid rgba(249,115,22,0.3)', margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>🍽️</div>
                    <div style={{ fontSize: 16, fontWeight: 800, color: '#fff', letterSpacing: '0.05em' }}>3AMENU</div>
                    <div style={{ fontSize: 11, color: '#555', marginTop: 3 }}>Dijital QR Menü</div>
                  </div>
                  <div style={{ padding: '14px 14px 8px' }}>
                    {[{ emoji: '☕', name: 'Sıcak İçecekler', count: 12 }, { emoji: '🥤', name: 'Soğuk İçecekler', count: 8 }, { emoji: '🍰', name: 'Tatlılar', count: 15 }].map((kat, i) => (
                      <div key={i} style={{ background: '#141414', borderRadius: 10, padding: '10px 12px', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 10, border: '1px solid #1e1e1e' }}>
                        <span style={{ fontSize: 18 }}>{kat.emoji}</span>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, color: '#e5e5e5' }}>{kat.name}</div>
                          <div style={{ fontSize: 10, color: '#444', marginTop: 1 }}>{kat.count} ürün</div>
                        </div>
                        <span style={{ color: '#333', fontSize: 12 }}>›</span>
                      </div>
                    ))}
                  </div>
                  <div style={{ padding: '6px 14px 14px', display: 'flex', gap: 6 }}>
                    <div style={{ flex: 1, background: '#141414', border: '1px solid #1e1e1e', borderRadius: 10, padding: '9px 0', textAlign: 'center', fontSize: 11, color: '#666' }}>🔔 Garson</div>
                    <div style={{ flex: 1.5, background: '#f97316', borderRadius: 10, padding: '9px 0', textAlign: 'center', fontSize: 11, color: '#fff', fontWeight: 700 }}>🛒 Sipariş (2)</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Ticker */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, borderTop: '1px solid #141414', overflow: 'hidden', background: '#0a0a0a' }}>
          <div style={{ display: 'flex', animation: 'ticker 20s linear infinite', whiteSpace: 'nowrap', padding: '12px 0' }}>
            {[...Array(2)].map((_, ri) => (
              <div key={ri} style={{ display: 'flex' }}>
                {['QR Menü', 'Dijital Sipariş', 'Garson Çağırma', 'Hesap İsteme', 'Ciro Raporu', 'AI Menü', 'Video Arka Plan', 'Sadakat Kartı', 'Kampanya Yönetimi'].map((item, i) => (
                  <span key={i} style={{ fontSize: 12, color: '#333', fontWeight: 600, padding: '0 32px', borderRight: '1px solid #1a1a1a', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                    <span style={{ color: '#f97316', marginRight: 8 }}>✦</span>{item}
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section style={{ borderBottom: '1px solid #141414', padding: '64px 24px', background: '#0a0a0a' }}>
        <div ref={statsRef} style={{ maxWidth: 1200, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24 }} className="stats-grid">
          {t.stats.map((stat, i) => (
            <div key={i} className={`fade-up d${i + 1} ${statsInView ? 'in' : ''}`} style={{ textAlign: 'center', padding: '32px 20px', background: '#0d0d0d', border: '1px solid #161616', borderRadius: 16 }}>
              <div style={{ fontSize: 48, fontWeight: 800, color: '#f97316', lineHeight: 1 }}>
                <Counter value={stat.value} unit={stat.unit} />
              </div>
              <div style={{ fontSize: 13, color: '#555', marginTop: 8, fontWeight: 500 }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section id="features" style={{ padding: '120px 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div ref={featRef} style={{ textAlign: 'center', marginBottom: 72 }}>
            <div className={`fade-up ${featInView ? 'in' : ''}`}><div className="tag" style={{ marginBottom: 20 }}>Özellikler</div></div>
            <div className={`fade-up d1 ${featInView ? 'in' : ''}`}><h2 style={{ fontSize: 'clamp(32px, 4vw, 56px)', fontWeight: 800, marginBottom: 16, letterSpacing: '-0.02em' }}>{t.features.title}</h2></div>
            <div className={`fade-up d2 ${featInView ? 'in' : ''}`}><p style={{ fontSize: 17, color: '#666', maxWidth: 480, margin: '0 auto' }}>{t.features.subtitle}</p></div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }} className="feat-grid">
            {t.features.list.map((f, i) => (
              <div key={i} className={`feat-card fade-up d${Math.min(i % 3 + 1, 4)} ${featInView ? 'in' : ''}`}>
                <div style={{ fontSize: 28, marginBottom: 16, filter: 'drop-shadow(0 0 8px rgba(249,115,22,0.3))' }}>{f.icon}</div>
                <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 8, color: '#e5e5e5' }}>{f.title}</h3>
                <p style={{ fontSize: 13, color: '#555', lineHeight: 1.7 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── KARŞILAŞTIRMA ── */}
      <section style={{ padding: '100px 24px', background: '#0a0a0a' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
          <div ref={compareRef} style={{ textAlign: 'center', marginBottom: 64 }}>
            <div className={`fade-up ${compareInView ? 'in' : ''}`}><div className="tag" style={{ marginBottom: 20 }}>Karşılaştırma</div></div>
            <div className={`fade-up d1 ${compareInView ? 'in' : ''}`}>
              <h2 style={{ fontSize: 'clamp(32px, 4vw, 56px)', fontWeight: 800, letterSpacing: '-0.02em' }}>{t.compare.title} <span style={{ color: '#f97316' }}>{t.compare.subtitle}</span></h2>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }} className="compare-grid">
            <div className={`fade-up d1 ${compareInView ? 'in' : ''}`} style={{ background: '#0d0d0d', border: '1px solid #1a1a1a', borderRadius: 20, padding: 32 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28 }}>
                <div style={{ width: 36, height: 36, borderRadius: 8, background: '#1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>📄</div>
                <span style={{ fontSize: 16, fontWeight: 700, color: '#555' }}>{t.compare.old.label}</span>
              </div>
              {t.compare.old.items.map((item, i) => (
                <div key={i} className="compare-item" style={{ color: '#444' }}><span style={{ color: '#2a2a2a', fontSize: 16 }}>✕</span>{item}</div>
              ))}
            </div>
            <div className={`fade-up d2 ${compareInView ? 'in' : ''}`} style={{ background: 'linear-gradient(160deg, #120900 0%, #0d0d0d 100%)', border: '1px solid rgba(249,115,22,0.25)', borderRadius: 20, padding: 32, position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: 'linear-gradient(90deg, transparent, #f97316, transparent)' }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28 }}>
                <div style={{ width: 36, height: 36, borderRadius: 8, background: 'rgba(249,115,22,0.15)', border: '1px solid rgba(249,115,22,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>⚡</div>
                <span style={{ fontSize: 16, fontWeight: 700, color: '#f97316' }}>{t.compare.new.label}</span>
              </div>
              {t.compare.new.items.map((item, i) => (
                <div key={i} className="compare-item" style={{ color: '#ccc' }}><span style={{ color: '#f97316', fontSize: 16 }}>✓</span>{item}</div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── NASIL ÇALIŞIR ── */}
      <section style={{ padding: '120px 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <div ref={howitRef} style={{ textAlign: 'center', marginBottom: 72 }}>
            <div className={`fade-up ${howitInView ? 'in' : ''}`}><div className="tag" style={{ marginBottom: 20 }}>Nasıl Çalışır</div></div>
            <div className={`fade-up d1 ${howitInView ? 'in' : ''}`}><h2 style={{ fontSize: 'clamp(32px, 4vw, 56px)', fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 14 }}>{t.howit.title}</h2></div>
            <div className={`fade-up d2 ${howitInView ? 'in' : ''}`}><p style={{ fontSize: 17, color: '#555' }}>{t.howit.subtitle}</p></div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24, position: 'relative' }} className="howit-grid">
            <div style={{ position: 'absolute', top: 52, left: '22%', right: '22%', height: 1, background: 'linear-gradient(90deg, transparent, #f97316, #f97316, transparent)', opacity: 0.2 }} />
            {t.howit.steps.map((step, i) => (
              <div key={i} className={`step-card fade-up d${i + 1} ${howitInView ? 'in' : ''}`}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
                  <div style={{ width: 48, height: 48, borderRadius: 12, background: 'rgba(249,115,22,0.1)', border: '1px solid rgba(249,115,22,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>{step.icon}</div>
                  <div style={{ fontSize: 28, fontWeight: 800, color: 'rgba(249,115,22,0.2)' }}>{step.num}</div>
                </div>
                <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12, color: '#e5e5e5' }}>{step.title}</h3>
                <p style={{ fontSize: 14, color: '#555', lineHeight: 1.7 }}>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FİYATLANDIRMA ── */}
      <section id="pricing" style={{ padding: '120px 24px', background: '#0a0a0a' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <div ref={pricingRef} style={{ textAlign: 'center', marginBottom: 60 }}>
            <div className={`fade-up ${pricingInView ? 'in' : ''}`}><div className="tag" style={{ marginBottom: 20 }}>Fiyatlar</div></div>
            <div className={`fade-up d1 ${pricingInView ? 'in' : ''}`}><h2 style={{ fontSize: 'clamp(32px, 4vw, 56px)', fontWeight: 800, marginBottom: 14, letterSpacing: '-0.02em' }}>{t.pricing.title}</h2></div>
            <div className={`fade-up d2 ${pricingInView ? 'in' : ''}`}>
              <p style={{ fontSize: 17, color: '#555', marginBottom: 36 }}>{t.pricing.subtitle}</p>
              <div style={{ display: 'inline-flex', background: '#0f0f0f', border: '1px solid #1e1e1e', borderRadius: 12, padding: 4, gap: 4 }}>
                {['monthly', 'yearly'].map(b => (
                  <button key={b} onClick={() => setBilling(b)} style={{ background: billing === b ? '#f97316' : 'transparent', color: billing === b ? '#fff' : '#555', border: 'none', borderRadius: 9, padding: '8px 20px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'Syne', transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: 8 }}>
                    {b === 'monthly' ? t.pricing.monthly : t.pricing.yearly}
                    {b === 'yearly' && <span style={{ background: billing === 'yearly' ? 'rgba(255,255,255,0.2)' : 'rgba(249,115,22,0.15)', color: billing === 'yearly' ? '#fff' : '#f97316', fontSize: 10, padding: '2px 7px', borderRadius: 100, fontWeight: 700 }}>{t.pricing.save}</span>}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }} className="pricing-grid">
            {t.pricing.plans.map((plan, i) => (
              <div key={i} className={`pricing-card ${plan.popular ? 'popular' : ''} fade-up d${i + 1} ${pricingInView ? 'in' : ''}`}>
                {plan.popular && (
                  <div style={{ position: 'absolute', top: 20, right: 20, background: 'rgba(249,115,22,0.15)', border: '1px solid rgba(249,115,22,0.3)', borderRadius: 100, padding: '4px 12px', fontSize: 11, fontWeight: 700, color: '#f97316' }}>EN POPÜLER</div>
                )}
                <div style={{ fontSize: 12, color: '#f97316', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 12 }}>{plan.name}</div>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 8 }}>
                  <span style={{ fontSize: 52, fontWeight: 800, color: '#fff', letterSpacing: '-0.03em' }}>₺{billing === 'monthly' ? plan.monthlyPrice : plan.yearlyPrice}</span>
                  <span style={{ color: '#444', fontSize: 13 }}>/{billing === 'monthly' ? (lang === 'tr' ? 'ay' : 'mo') : (lang === 'tr' ? 'yıl' : 'yr')}</span>
                </div>
                <p style={{ color: '#555', fontSize: 13, marginBottom: 28, lineHeight: 1.6 }}>{plan.desc}</p>
                <div style={{ marginBottom: 32, display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {plan.features.map((f, j) => (
                    <div key={j} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                      <span style={{ color: '#f97316', fontSize: 13, marginTop: 1, flexShrink: 0 }}>✓</span>
                      <span style={{ fontSize: 13, color: j === 0 && plan.popular ? '#f97316' : '#999', fontWeight: j === 0 && plan.popular ? 600 : 400 }}>{f}</span>
                    </div>
                  ))}
                </div>
                <a href={WA} target="_blank" rel="noreferrer"
                  style={{ display: 'block', textAlign: 'center', textDecoration: 'none', background: plan.popular ? '#f97316' : 'transparent', color: plan.popular ? '#fff' : '#666', border: plan.popular ? 'none' : '1px solid #2a2a2a', borderRadius: 10, padding: '14px 0', fontSize: 14, fontWeight: 700, fontFamily: 'Syne', cursor: 'pointer', transition: 'all 0.25s' }}
                  onMouseEnter={e => { if (!plan.popular) { e.target.style.borderColor = '#f97316'; e.target.style.color = '#f97316'; } else { e.target.style.background = '#ea6d15'; } }}
                  onMouseLeave={e => { if (!plan.popular) { e.target.style.borderColor = '#2a2a2a'; e.target.style.color = '#666'; } else { e.target.style.background = '#f97316'; } }}
                >{plan.cta} →</a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SSS ── */}
      <section id="faq" style={{ padding: '120px 24px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <div ref={faqRef} style={{ textAlign: 'center', marginBottom: 64 }}>
            <div className={`fade-up ${faqInView ? 'in' : ''}`}><div className="tag" style={{ marginBottom: 20 }}>SSS</div></div>
            <div className={`fade-up d1 ${faqInView ? 'in' : ''}`}><h2 style={{ fontSize: 'clamp(32px, 4vw, 56px)', fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 14 }}>{t.faq.title}</h2></div>
            <div className={`fade-up d2 ${faqInView ? 'in' : ''}`}><p style={{ fontSize: 17, color: '#555' }}>{t.faq.subtitle}</p></div>
          </div>
          <div className={`fade-up d2 ${faqInView ? 'in' : ''}`}>
            {t.faq.list.map((item, i) => <FaqItem key={i} q={item.q} a={item.a} />)}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section id="contact" style={{ padding: '140px 24px', position: 'relative', overflow: 'hidden', textAlign: 'center', background: '#0a0a0a' }}>
        <div style={{ position: 'absolute', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(249,115,22,0.09) 0%, transparent 70%)', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', border: '1px solid rgba(249,115,22,0.06)', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', animation: 'spin-slow 20s linear infinite', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', width: 600, height: 600, borderRadius: '50%', border: '1px solid rgba(249,115,22,0.04)', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', animation: 'spin-slow 30s linear infinite reverse', pointerEvents: 'none' }} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div className="tag" style={{ marginBottom: 28, display: 'inline-flex' }}>İletişim</div>
          <h2 style={{ fontSize: 'clamp(36px, 5vw, 68px)', fontWeight: 800, marginBottom: 20, letterSpacing: '-0.03em', lineHeight: 1.05 }}>{t.cta.title}</h2>
          <p style={{ fontSize: 18, color: '#555', marginBottom: 48 }}>{t.cta.subtitle}</p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={WA} target="_blank" rel="noreferrer" className="btn-orange" style={{ fontSize: 16, padding: '16px 40px' }}>💬 {t.cta.button}</a>
            <a href="mailto:info@3amenu.com" className="btn-ghost" style={{ fontSize: 16, padding: '16px 40px' }}>📧 info@3amenu.com</a>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={{ borderTop: '1px solid #111', padding: '32px 24px' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 18, fontWeight: 800, color: '#f97316' }}>3A</span>
            <span style={{ fontSize: 18, fontWeight: 800, color: '#fff' }}>Menu</span>
            <span style={{ color: '#222', margin: '0 8px' }}>·</span>
            <span style={{ fontSize: 12, color: '#333' }}>{t.footer.rights}</span>
          </div>
          <div style={{ display: 'flex', gap: 24 }}>
            {t.footer.links.map((l, i) => (
              <a key={i} href="#" style={{ fontSize: 12, color: '#333', textDecoration: 'none' }}
                onMouseEnter={e => e.target.style.color = '#666'}
                onMouseLeave={e => e.target.style.color = '#333'}>{l}</a>
            ))}
            <a href="/superadmin" style={{ fontSize: 12, color: '#111', textDecoration: 'none' }}>·</a>
          </div>
        </div>
      </footer>
    </div>
  );
}